import { fetchEnteriseAppList, fetchEnterpriseAppInfo, fetchEnteriseAppServiceList } from '@/api/enteriseApp';

const enteriseApp = {
  state: {},

  mutations: {},

  actions: {
    // 查询企业应用列表
    getEnteriseAppList(_, resdata) {
      return new Promise((resolve, reject) => {
        fetchEnteriseAppList(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 查询企业应用服务商列表
    getEnteriseAppServiceList(_, resdata) {
      return new Promise((resolve, reject) => {
        fetchEnteriseAppServiceList(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    },
    // 查询企业应用列表
    getEnterpriseAppInfo(_, resdata) {
      return new Promise((resolve, reject) => {
        fetchEnterpriseAppInfo(resdata)
          .then(response => {
            resolve(response);
          })
          .catch(error => {
            reject(error);
          });
      });
    }
  }
};

export default enteriseApp;



// WEBPACK FOOTER //
// ./src/store/modules/enteriseApp.js